var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIconCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.845474,
    width: 24,
    height: 24,
    rx: 12,
    fill: "#278DEC",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.84547 8.6875L11.7444 11.9024C12.1411 12.1628 12.3395 12.2929 12.5552 12.3434C12.7458 12.3879 12.9451 12.3879 13.1357 12.3434C13.3515 12.2929 13.5498 12.1628 13.9465 11.9024L18.8455 8.6875M9.72547 16H15.9655C16.9736 16 17.4776 16 17.8627 15.8161C18.2013 15.6543 18.4767 15.3961 18.6493 15.0786C18.8455 14.7176 18.8455 14.2451 18.8455 13.3V9.7C18.8455 8.75491 18.8455 8.28237 18.6493 7.92139C18.4767 7.60387 18.2013 7.34571 17.8627 7.18393C17.4776 7 16.9736 7 15.9655 7H9.72547C8.71738 7 8.21333 7 7.82829 7.18393C7.4896 7.34571 7.21423 7.60387 7.04166 7.92139C6.84547 8.28237 6.84547 8.75491 6.84547 9.7V13.3C6.84547 14.2451 6.84547 14.7176 7.04166 15.0786C7.21423 15.3961 7.4896 15.6543 7.82829 15.8161C8.21333 16 8.71738 16 9.72547 16Z",
    stroke: "#278DEC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIconCircle);
export default __webpack_public_path__ + "static/media/mailIconCircle.e14fcd666b0d3f0121913f7ca06686ca.svg";
export { ForwardRef as ReactComponent };